var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","color":"#3374ff","id":"nav"}},[_c('a',{staticClass:"white--text",attrs:{"href":"https://oeaq.qc.ca/","target":"_blank"}},[_vm._v("Ordre des Évaluateurs Agréés du Québec")])])}
var staticRenderFns = []

export { render, staticRenderFns }